module.exports = __webpack_public_path__ + "static/img/底部按钮01.108d066.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/pagess/gdd116/底部按钮01.gif
// module id = bTxv
// module chunks = 1